<template>
  <div>
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="24">
        <el-col :span="6">
          <el-input placeholder="请输入姓名或手机号" v-model="queryInfo.cite" clearable @clear="queryVcardTheme"></el-input>
        </el-col>
        <el-col :span="3">
          <el-button icon="el-icon-search" type="success" @click="queryVcardTheme">搜索</el-button>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" icon="el-icon-plus" @click="addCardTheme">新增</el-button>
        </el-col>
        <el-col :span="6">
          <el-radio-group v-model="queryInfo.status" @change="queryVcardTheme">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button :label="1">启用</el-radio-button>
            <el-radio-button :label="9">停用</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>
      <small style="color:#F56C6C;">注：停用表示不能被用户再选择作为名片主题，但不影响已选择用户名片的继续使用。</small>

      <!-- 用户列表区域 -->
      <el-table :data="tableData" stripe>
        <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
        <el-table-column label="创建日期" prop="create_dt" min-width="100">
          <template slot-scope="scope">
            {{scope.row.create_dt | formatDate}}
          </template>
        </el-table-column>
        <el-table-column label="类型" min-width="80">
          <template slot-scope="scope">
            <span style="margin-left:10px;" :style="scope.row.style_type === '样式II'?'':'color:#EB5753'">{{scope.row.style_type}}</span>
          </template>
        </el-table-column>
        <el-table-column label="主题样式" min-width="150">
          <template slot-scope="scope">
            <div style="position: relative;">
              <img :src="scope.row.background_url" style="height: 80px;" />
              <div style="position: absolute;top:30px;left:80px" :style="{'color':scope.row.fore_color,'left':'样式I'==scope.row.style_type?'80px':'20px'}">前景色</div>
              <div v-if="'样式I'==scope.row.style_type" style="position: absolute;top:30px;left:10px;" :style="{'color':scope.row.fore_color_2}">前景色2</div>
              <div v-if="'样式I'==scope.row.style_type" style="position: absolute;top:50px;left:80px;">
                <span style="border-radius: 18px;padding:2px 1px 0px 1px;" :style="{'background':scope.row.background_color}">
                  <i class="el-icon-eleme" :style="{'color':scope.row.fore_color_2}"></i>
                </span>
                <span :style="{'color':scope.row.background_color}">背景色</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="名称" prop="name" min-width="100"></el-table-column>
        <el-table-column label="前景色 背景色" prop="fore_color" min-width="100">
          <template slot-scope="scope">
            <div :style="{'color':scope.row.fore_color}">{{scope.row.fore_color}}</div>
            <div :style="{'color':scope.row.fore_color_2}">{{scope.row.fore_color_2}}</div>
            <div :style="{'color':scope.row.background_color}">{{scope.row.background_color}}</div>
          </template>
        </el-table-column>
        <el-table-column label="状态 默认" min-width="80">
          <template slot-scope="scope">
            <span :style="scope.row.status === '启用'?'color:#6FC334':'color:#EB5753'">{{scope.row.status}}</span>
            <span style="margin-left:10px;" :style="scope.row.is_default === '否'?'color:#EB5753':'color:#6FC334'">{{scope.row.is_default}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250" align="center">
          <template slot-scope="scope">
            <el-button-group>
              <el-button size="medium" type="warning" @click="showEditDialog(scope.row)">修改</el-button>
            </el-button-group>
            <el-button-group style="margin-left:10px;">
              <el-button size="medium" type="success" :disabled="scope.row.status == '启用' ? true :false" @click="statusVcardTheme(scope.row.id,1)">启用</el-button>
              <el-button size="medium" type="danger" :disabled="scope.row.status == '启用' ? false :true" @click="statusVcardTheme(scope.row.id,9)">停用</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <div style="text-align: right">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.page_ix" :page-size="queryInfo.page_size" layout="prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </el-card>

    <!-- 添加用户的对话框 -->
    <el-dialog :title="formTitle" :visible.sync="dialogFormVisible" width="50%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="cardThemeForm" :rules="cardThemeFormRules" ref="cardThemeForm" label-width="100px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="cardThemeForm.name"></el-input>
        </el-form-item>
        <el-form-item label="背景图片" v-if="showFalse">
          <el-upload class="avatar-uploader" action="#" accept="image/png, image/jpeg, image/gif, image/jpg" :show-file-list="false" list-type="picture" align="left" :on-remove="handleRemove" :http-request="uploadPic" ref="upload">
            <img v-if="imageUrl" :src="cardThemeForm.background_url" class="avatar">
            <div v-else>
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <div>上传图片</div>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="文字前景色" prop="phoneno">
          <el-input v-model="cardThemeForm.fore_color"></el-input>
        </el-form-item>
        <el-form-item label="文字前景色2" prop="fore_color_2">
          <el-input v-model="cardThemeForm.fore_color_2"></el-input>
        </el-form-item>
        <el-form-item label="背景色" prop="background_color">
          <el-input v-model="cardThemeForm.background_color"></el-input>
        </el-form-item>
        <el-form-item label="样式类型">
          <el-radio-group v-model="cardThemeForm.style_type">
            <el-radio :label="1">类型I</el-radio>
            <el-radio :label="2">类型II</el-radio>
          </el-radio-group>
          <div>
            <small style="color:#F56C6C;">注：样式I-传统式，样式II-图片式。</small>
          </div>
        </el-form-item>
        <el-form-item label="系统默认">
          <el-radio-group v-model="cardThemeForm.is_default">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
          <div>
            <small style="color:#F56C6C;">注：设置本样式为系统默认后，将设置其他样式为非系统默认。</small>
          </div>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('cardThemeForm',add_edit)">保存设置</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      type: '',
      formTitle: '名片背景信息',
      add_edit: '',
      // 获取用户列表的参数对象
      queryInfo: {
        status: '1',
        cite: '',
        // 当前的页数
        page_ix: 1,
        // 当前每页显示多少条数据
        page_size: 10
      },
      tableData: [],
      total: 10, // 分页总数
      // 控制添加用户对话框的显示与隐藏
      dialogFormVisible: false,
      // 用户的表单数据
      cardThemeForm: {
        theme_id: '',
        name: '',
        fore_color: '',
        fore_color_2: '',
        is_default: '',
        background_url: '',
        background_color: '',
        style_type: ''
      },
      // 添加表单的验证规则对象
      cardThemeFormRules: {},
      limit: 1,
      fileList: [],
      imageUrl: false,
      showFalse: false
    }
  },
  created() {
    this.queryVcardTheme()
  },
  methods: {
    async queryVcardTheme() {
      this.$axios.post('/admin/Vcard/queryVcardTheme', this.queryInfo).then(res => {
        if (res.data.rst == 0) {
          this.tableData = res.data.data.data
          this.total = res.data.data.total
          this.tableData.forEach(e => {
            e.status = e.status == 1 ? '启用' : '停用'
            e.is_default = !e.is_default ? '否' : '是'
            e.style_type = e.style_type == 2 ? '样式II' : '样式I'
          })
        } else {
          this.alertError(res.data.msg)
        }
      }).catch(err => {
        console.error('错误：', err)
      })
    },
    // 监听 page_size 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.page_size = newSize
      this.queryVcardTheme()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      // console.log(newPage)
      this.queryInfo.page_ix = newPage
      this.queryVcardTheme()
    },
    // 监听用户对话框的关闭事件
    addDialogClosed() {
      this.$refs.cardThemeForm.resetFields()
    },
    addCardTheme() {
      this.add_edit = 'add'
      this.dialogFormVisible = true
      this.imageUrl = false
      this.showFalse = false
      this.cardThemeForm = {}
      console.log('this.cardThemeForm ', this.cardThemeForm)
    },
    // 展示编辑用户的对话框
    showEditDialog(row) {
      this.add_edit = 'edit'
      this.dialogFormVisible = true
      this.showFalse = true
      Object.assign(this.cardThemeForm, row)
      this.cardThemeForm.style_type = this.cardThemeForm.style_type === '样式II' ? 2 : 1
      this.cardThemeForm.is_default = this.cardThemeForm.is_default === '是' ? 1 : 0
      this.cardThemeForm.status = this.cardThemeForm.status === '启用' ? 1 : 9
      console.log('this.cardThemeForm ', this.cardThemeForm)
    },
    // 提交表单
    submitForm(formName, type) {
      // // 开启登录加载动画
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (type == 'edit') {
            // this.cardThemeForm.status = this.cardThemeForm.status ? 1 : 9;
            let editparams = {
              theme_id: this.cardThemeForm.id,
              name: this.cardThemeForm.name,
              status: this.cardThemeForm.status,
              fore_color: this.cardThemeForm.fore_color,
              fore_color_2: this.cardThemeForm.fore_color_2,
              is_default: this.cardThemeForm.is_default,
              style_type: this.cardThemeForm.style_type,
              background_url: this.cardThemeForm.background_url,
              background_color: this.cardThemeForm.background_color
            }
            this.$axios.post('/admin/Vcard/saveVcardTheme', editparams).then(res => {
              if (res.data.rst == 0) {
                this.alertSuccess(res.data.msg)
                this.queryVcardTheme()
                this.dialogFormVisible = false
              } else {
                this.alertError(res.data.msg)
              }
            }).catch(err => {
              console.error('错误：', err)
            })
          } else {
            let editparams = {
              name: this.cardThemeForm.name,
              status: this.cardThemeForm.status,
              fore_color: this.cardThemeForm.fore_color,
              fore_color_2: this.cardThemeForm.fore_color_2,
              background_color: this.cardThemeForm.background_color,
              is_default: this.cardThemeForm.is_default,
              style_type: this.cardThemeForm.style_type
            }

            this.$axios.post('/admin/Vcard/saveVcardTheme', editparams).then(res => {
              if (res.data.rst == 0) {
                this.alertSuccess(res.data.msg)
                this.queryVcardTheme()
                this.dialogFormVisible = false
              } else {
                this.alertError(res.data.msg)
              }
            }).catch(err => {
              console.error('错误：', err)
            })
          }
        } else {
          return false
        }
      })
    },
    // 根据Id删除对应的用户信息
    async statusVcardTheme(id, status) {
      // 弹框询问用户是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将' + (status == 1 ? '启用' : '停用') + '所选样式, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      let editparams = {
        theme_id: id,
        status: status
      }
      this.$axios.post('/admin/Vcard/saveVcardTheme', editparams).then(res => {
        if (res.data.rst == 0) {
          this.alertSuccess(res.data.msg)
          this.queryVcardTheme()
        } else {
          this.alertError(res.data.msg)
        }
      }).catch(err => {
        console.error('错误：', err)
      })
    },
    uploadPic(file) {
      var formdata = new FormData()
      // console.log('file',file.file.type.split('/')[1])
      formdata.append('theme_id', this.cardThemeForm.id)
      formdata.append('background', file.file)
      formdata.append('ext', file.file.type.split('/')[1])
      this.$axios.post('/admin/Vcard/uploadVcardThemeBackground', formdata).then(res => {
        if (res.data.rst == 0) {
          this.cardThemeForm.background_url = res.data.data
          this.imageUrl = true
        } else {
          this.alertError(res.data.msg)
        }
      }).catch(err => {
        console.error('错误：', err)
      })
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
      this.fileList = []
      this.cardThemeForm.background_url = ''
    },
    // 成功弹窗
    alertSuccess(msg) {
      this.$message.success({
        showClose: true,
        duration: 1000,
        message: msg,
        type: 'success'
      })
    },
    // 错误消息
    alertError(msg) {
      this.$message.error({
        duration: 1000,
        showClose: true,
        message: msg,
        type: 'error'
      })
    }
  }

}
</script>

<style lang="less">
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
